function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkoutIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2246",
    xmlns: "http://www.w3.org/2000/svg",
    width: 422.869,
    height: 390.228,
    viewBox: "0 0 422.869 390.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cpbcmtlela"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 305",
    style: {
      fill: "none"
    },
    d: "M0 0h422.869v390.228H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1973",
    style: {
      clipPath: "url(#cpbcmtlela)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2042",
    d: "M72.432 312.607c.233-2.893.134-5.843.263-8.7.255-5.651.544-11.3.91-16.946.736-11.358 1.568-22.727 2.947-34.027 1.21-9.914 1.942-21.71 7.582-30.3 2.623-3.994 6.675-8.2 11.26-9.857 4.635-1.677 9.194.037 13.243 2.392a.554.554 0 0 0 .559-.957c-5.49-3.193-11.373-4.553-17.06-1.054a30.4 30.4 0 0 0-12.58 16.76c-2.646 8.4-3.51 17.531-4.49 26.253-1.111 9.882-1.839 19.808-2.5 29.729a810.036 810.036 0 0 0-.883 15.886c-.162 3.455.02 7.148-.308 10.7.348.049.7.092 1.057.126",
    style: {
      fill: "#5d4920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2043",
    d: "M67.566 312.071c.771.1 1.545.155 2.317.231-2.28-9.55-1.238-19.8-1.512-29.523-.382-13.512-.739-27.028-1.461-40.528-.62-11.589-1.49-24.221-6.062-35.134q-.423.28-.862.529A84.016 84.016 0 0 1 64 223.779a179.878 179.878 0 0 1 1.885 20.092c.656 12.78 1 25.573 1.36 38.364.27 9.563-.732 19.683 1.269 29.148a78.356 78.356 0 0 1-2.314-13.774c-.854-7.661-1.961-15.133-4.527-22.445-2.656-7.567-6.7-14.31-10.269-21.44-2.575-5.141-5.323-11.408-11.147-13.527-6.872-2.5-14.171 1.284-17.431 7.5-.331.631.624 1.192.956.56a13.789 13.789 0 0 1 11.742-7.715c4.741-.1 8.323 2.562 10.883 6.338 2.171 3.2 3.628 6.815 5.484 10.2a146.736 146.736 0 0 1 6.717 13.245c3.737 8.81 5.429 17.835 6.484 27.292.521 4.69 1.016 9.783 2.469 14.454",
    style: {
      fill: "#5d4920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2044",
    d: "M114.145 231.556a20.573 20.573 0 0 0-20.222 4.185C88.007 240.8 85.4 248.729 83.6 256.052c-2.182 8.865-3.981 17.924-5.479 26.926-1.65 9.908-3 19.884-5.341 29.652.385.03.771.043 1.155.041 1.627-6.854 2.772-13.813 3.872-20.776 1.357-8.581 2.968-17.065 4.711-25.573 2.853-13.91 6.884-34.8 25.13-34.87 5.721-.022 17.118 3.968 17.346 10.859.023.711 1.131.715 1.107 0-.194-5.879-7.172-9.137-11.951-10.755",
    style: {
      fill: "#5d4920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2045",
    d: "M112.671 198.184c-5.2-1.994-12.579 2.161-13.49 7.8-3.767-2.181-9.626-2.611-11.265 2.272-2.546 7.586 6.854 11.992 10.973 16.178a.837.837 0 0 0 1.431-.721 51.208 51.208 0 0 1-1.144-7.542c-.087-.965.321-2.137 1.271-2.322a1.747 1.747 0 0 1 1.827 1.318c.59 1.917-.468 4.679-.581 6.67-.1 1.787-.443 3.885 1.151 5.091a5.679 5.679 0 0 0 3.383.713c3.4.109 5.63-.151 8.887 1.395a.845.845 0 0 0 1.277-.654c.476-3.142 2.446-5.275 3.276-8.182a4.6 4.6 0 0 0-.294-3.694 4.329 4.329 0 0 0-2.858-1.826c-.563-.156-3.226-.121-3.551-.607q.657-4.854 4-1.869.8 1.3 1.648 2.58a.838.838 0 0 0 1.572-.325c1.068-6.011-1.355-13.913-7.513-16.275",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2046",
    d: "M81 203.861c-2.086-2.818-5.431-4.4-7.656-7.187a.562.562 0 0 1 .015-.795.6.6 0 0 1 .1-.075c2.661-1.276 4.892.207 6.714 2.639a16.63 16.63 0 0 0-1.8-4.09c-3.5-5.643-10.094-8.806-16.59-9.109-4.794-.223-11.336.453-14.121 4.841-3.9-4.108-11.242-4.556-16.235-2.572-6.712 2.667-10.889 9.525-11.6 16.535a23.79 23.79 0 0 0 .122 5.979c1.034-1.336 2.162-2.582 3.141-3.665 1.4-1.548 4.892-5.79 7.477-4.754 3.439 1.378-.747 5.647-1.981 6.859-1.831 1.8-4.041 3.373-5.338 5.624q-.675 1.184-1.229 2.429a29.648 29.648 0 0 0 4.5 6.437c.47.524.953 1.037 1.431 1.555a26.147 26.147 0 0 1 1.658-6.961c.77-2.14 2.62-7.278 5.7-6.853 4.5.622 1.188 6.85 0 8.772-1.245 2.01-3.189 4.135-3.551 6.526-.4 2.667 1.159 5.487 2.884 7.386 2.1 2.31 4.8 3.967 7.158 6.015s4.452 4.727 4.644 7.844c1.135-2.841 3.648-4.879 6.188-6.582s5.263-3.253 7.211-5.611c3.778-4.571 1.728-9.024-.9-13.441-1.111-1.868-2.377-6.051 1.091-6.409 3.32-.343 5.63 4.12 6.394 6.656a19.51 19.51 0 0 1 .522 7.835 45.653 45.653 0 0 0 7.225-6.581 16.37 16.37 0 0 0-.924-5.849c-.987-2.611-2.943-4.415-4.513-6.646-1.3-1.846-3.017-6.339.72-6.721 3.255-.333 6.7 3.785 8.163 6.245a18.973 18.973 0 0 1 1.761 3.971c.036-.109.085-.207.121-.317a30.266 30.266 0 0 0 1.5-9.93m-43.875-.281a1.433 1.433 0 0 1-1.572 1.281 1.4 1.4 0 0 1-.264-.052.565.565 0 0 1-.407-.534 1.512 1.512 0 0 1 .075-.4.479.479 0 0 1 .084-.64 1.694 1.694 0 0 1 1.7-.34.567.567 0 0 1 .381.685zm1.285-3.4a.587.587 0 0 1-.537-.632v-.025a1 1 0 0 1 .367-.974 1.662 1.662 0 0 1 2.082-.477.562.562 0 0 1 .254.626 2.1 2.1 0 0 1-2.17 1.478zm3.118 3.5c-.552.354-1.431.676-1.98.144a1.426 1.426 0 0 1 .2-2.007l.013-.01a6.227 6.227 0 0 1 1.944-1.191.581.581 0 0 1 .708.193.5.5 0 0 1 .316.349 2.363 2.363 0 0 1-1.2 2.52zm16.26-2.416c-1.051-.067-2.544-.779-2.641-1.975a1.585 1.585 0 0 1 1.22-1.682.429.429 0 0 1 .4-.135c.066.009.134.025.2.039a2.4 2.4 0 0 1 .791.087.511.511 0 0 1 .348.321 3.123 3.123 0 0 1 1.352 1.277c.583 1.156-.553 2.138-1.671 2.067zm2.26-7.168a8.088 8.088 0 0 1-5.126 1.175c-1.513-.13-3.5-1.309-1.779-2.791 1.49-1.284 4.547-2.075 6.336-1.066a.5.5 0 0 1 .221.25 1.554 1.554 0 0 1 .755.551 1.367 1.367 0 0 1-.407 1.88z",
    style: {
      fill: "#99991e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2047",
    d: "M48 197.478a10.322 10.322 0 0 0-7.623-7.583c-3.224-.8-7.191-.878-10.156.842a.471.471 0 0 0-.565.129 11.623 11.623 0 0 0-2.647 4.045c-.146.428.3.76.681.682 1.87-.378 3.537-1.463 5.412-1.932a13.026 13.026 0 0 1 6.882-.28 8.91 8.91 0 0 1 5.234 4.534 23.991 23.991 0 0 1 1.89 4.8 50.6 50.6 0 0 1 .649 2.513 10.755 10.755 0 0 1 .138 2.274c.087 3.664.017 7.328-.07 10.992-.13 5.428-.274 10.86-.008 16.287.035.71.626 2.018.591 1.3-.352-7.171.186-14.321.45-21.484.2-5.55.668-11.692-.858-17.119",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2048",
    d: "M45.007 248.74a16.534 16.534 0 0 0-6.168-7.193 13.482 13.482 0 0 0-9.143-2.464c-2.854.373-4.113 2.076-6.177 3.544-.152-4.67-3.911-7.346-8.483-7.217a11.6 11.6 0 0 0-1.725.184 10.277 10.277 0 0 1 3.381 8.27.562.562 0 0 1-.945.392c-2.478-2.065-3.882-5.166-6.441-7.12a14.2 14.2 0 0 0-3.151 2.674c3.359 1.462 6.38 4.709 6.077 7.8a.561.561 0 0 1-.569.553.582.582 0 0 1-.131-.018 11.607 11.607 0 0 1-3.289-1.912 8.809 8.809 0 0 0-5.117-1.822 34.279 34.279 0 0 0-2.646 6.751c4.893-1.76 10.5-2.42 13.156 2.321a.569.569 0 0 1-.2.758c-3.415 2.464-7.871-1.284-11.286 1.338A7.666 7.666 0 0 0 0 258.366a13.661 13.661 0 0 0 .4 1.788 18.1 18.1 0 0 0 2.221 4.6c2.781-2.336 6.967-5.675 9.52-3.41a.559.559 0 0 1 0 .784c-2 1.987-4.557 3.386-6.067 5.836-.16.26-.308.531-.451.808a15.5 15.5 0 0 1 2.483 4.086c.588 1.6.527 3.283 1.268 4.834a.566.566 0 0 0 .757.2 43.216 43.216 0 0 1 9.9-2.609c.1-2.029-.843-3.8-1.719-6.024a4.54 4.54 0 0 1-.28-3.486 2.86 2.86 0 0 1 4.827-.841c2.06 2.282 2.249 6.119 1.3 9.586A33.579 33.579 0 0 0 31 272.475c.256-.112.5-.239.752-.363a8.719 8.719 0 0 0-.428-2.006c-.375-1.07-1.014-2-1.461-3.034a5.332 5.332 0 0 1-.149-4.591c.91-1.937 2.964-3.31 4.812-1.622 2.23 2.038 2.063 5.309 1.16 8.616a30.685 30.685 0 0 0 6.067-7.42 14.07 14.07 0 0 0-4.838-8.685c-1.326-1.045-3.678-2.094-4.249-3.83-1.048-3.194 4.117-3.319 5.834-1.976 3.02 2.364 3.744 7.382 4.264 10.9.074.5.129 1 .193 1.494.425-.782.828-1.566 1.209-2.344 1.411-2.869 2.095-5.828.843-8.869m-29.546-.818-.235-.47c-.318-.637.638-1.2.956-.559l.235.47c.318.632-.638 1.2-.956.559m4.342-.432c-1.086.227-1.868-1.841-1.057-2.488a1.066 1.066 0 0 1 .988-.132c.38.126.943.475.942.934 0 .619-.137 1.532-.874 1.691zm2.614 12.979a1.054 1.054 0 0 1-1-.889c-.068-.508.546-1.524 1.135-1.138.4.26.944.583.95 1.123a.912.912 0 0 1-.9.921.931.931 0 0 1-.183-.017zm8.4-3.582c-.149.6-1.495.711-1.88.309a2.527 2.527 0 0 1-.012-3.535.557.557 0 0 1 .67-.087 2.907 2.907 0 0 1 1.216 3.313z",
    style: {
      fill: "#99991e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2049",
    d: "M41.863 245.289c-1.864-1.375-3.713-2.431-6.092-2.379a.554.554 0 0 0 0 1.108c2.185-.048 3.833.974 5.533 2.228.574.424 1.127-.538.559-.957",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2050",
    d: "M42.946 248.043a2.141 2.141 0 0 1-.4-.494.554.554 0 0 0-.956.56 3.173 3.173 0 0 0 .571.718c.521.488 1.305-.295.785-.784",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2051",
    d: "M38.492 256.145a2.349 2.349 0 0 0-.469-.336 7.041 7.041 0 0 0-1.066-.783c-.409-.2-.716.224-.711.648a1.109 1.109 0 0 0 .369.775 1.927 1.927 0 0 0 .77.413 1.354 1.354 0 0 0 .671.057.649.649 0 0 0 .494-.421.368.368 0 0 0-.058-.353",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2052",
    d: "M38.73 259.952v1.576c0 .945 1.126.392 1.377-.085a1.753 1.753 0 0 0 .173-.681 1.493 1.493 0 0 0-.133-.835c-.266-.486-1.417-.821-1.417.025",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2053",
    d: "M36.417 258.624a1.59 1.59 0 0 0-1-.384.429.429 0 0 0-.388.355.581.581 0 0 0 .243.431 3.529 3.529 0 0 0 .883.587c.151.07.354.119.46-.009a.391.391 0 0 0 .061-.262 1.242 1.242 0 0 0-.057-.461.7.7 0 0 0-.2-.257",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2054",
    d: "M27.83 264.048c-.227-.672-1.3-.384-1.068.294.181.536 0 1.145.316 1.641a.589.589 0 0 0 .559.3c.44-.073.321-.532.325-.838a3.99 3.99 0 0 0-.132-1.4",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2055",
    d: "M13.224 263.66c-.576.121-1.77.7-1.853 1.389a.166.166 0 0 0 .108.185.243.243 0 0 0 .107-.009l1-.238c.341-.081 1.123-.214 1.3-.57.2-.406-.281-.837-.662-.757",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2056",
    d: "M14.059 265.934a.7.7 0 0 0-.987.083.778.778 0 0 0-.058.08 3.623 3.623 0 0 0-.476 1.986.42.42 0 0 0 .662.319 1.43 1.43 0 0 0 .305-.259l.5-.517a1.668 1.668 0 0 0 .475-.7.827.827 0 0 0-1.033-1 .873.873 0 0 1 .7.092",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2057",
    d: "M10.3 270.716a2.95 2.95 0 0 0-.141 1.36c.083.7 1.192.708 1.107 0a2.24 2.24 0 0 1 .1-1.065c.234-.674-.832-.963-1.066-.295",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2058",
    d: "M13.976 272.369a.555.555 0 1 0 .531.531.555.555 0 0 0-.531-.531",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2059",
    d: "M27.054 268.611a.555.555 0 1 0 .521.521.555.555 0 0 0-.521-.521",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2060",
    d: "M29.078 270.222a.579.579 0 0 0-.447-.477l-.1-.023c-.815-.192-.783 1.065-.643 1.541.063.214.2.443.418.472a.567.567 0 0 0 .487-.278 1.764 1.764 0 0 0 .285-1.235",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2061",
    d: "M38.95 263.682h.021c-.154-.7-1.221-.4-1.068.295a1.015 1.015 0 0 0 .263.487c.465.544 1.244-.243.784-.782",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2062",
    d: "m45.487 251.438-.121-.121a.554.554 0 1 0-.783.784l.121.121a.554.554 0 0 0 .783-.784",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2063",
    d: "M107.146 244.427c-.7-2.667-1.377-6.08-3.833-7.756-2.365-1.614-5.509-.659-7.716.791a11.051 11.051 0 0 0-3.067 2.986c-1.142 1.68-1.677 3.709-3.434 4.828-2.835-2.91-.613-8.017-2.092-11.536-1.343-3.194-4.912-4.337-7.985-5.178-6.345-1.738-16.8-2.066-20.123 5.141-.11.238-.035.636.286.678 4.334.57 10.519-1.858 14.061 1.713.481.485 1.808 2.005 1.767 2.754-.086 1.6-1.862.831-2.691.55a48.32 48.32 0 0 0-4.948-1.651c-4.146-.935-9.1-1.152-12.72 1.439-3.1 2.216-4.248 5.923-4.6 9.559-.037.394.42.525.7.4 2.949-1.32 5.757-3.025 8.966-3.637a18.155 18.155 0 0 1 8.592.465c.7.2 3.63.774 2.764 1.981-.293.41-2.175.167-2.64.141-2.263-.126-4.508-.291-6.779-.217-4.279.139-9.988.8-12.688 4.611-2.319 3.274-1.775 7.71-2 11.492a.468.468 0 0 0 .477.461.461.461 0 0 0 .223-.061c2.55-1.443 4.627-3.548 7.145-5.036a27.838 27.838 0 0 1 9.342-3.193c1.388-.248 5.466-1.567 6.647-.687 1.389 1.035-1.167 1.919-1.816 2.183-1.19.484-2.419.88-3.634 1.294-4.7 1.6-9.849 3.23-13.274 7.053-2.65 2.957-2.3 7.244-1.01 10.759a.472.472 0 0 0 .587.318.447.447 0 0 0 .1-.044c5.667-3.618 10.918-7.829 16.453-11.64a13.557 13.557 0 0 1 3.5-1.986q1.308-.762 1.555.817 1.185 1-.049 1.833a8.806 8.806 0 0 1-1.412 1.224 41.316 41.316 0 0 1-5.54 3.124c-3.436 1.767-7.413 3.749-9.175 7.411-2.2 4.569.867 8.618 3.7 12.049a.464.464 0 0 0 .656-.01 14.787 14.787 0 0 0 2.062-4.565 15.893 15.893 0 0 1 4.649-6.8 35.019 35.019 0 0 1 5.247-3.643c.75-.442 3.4-2.188 3.663-.317.106.755-1.187 2.122-1.622 2.608-2.73 3.057-6.6 4.91-9.058 8.247-2.677 3.628-1.157 6.476 2.282 8.837a.468.468 0 0 0 .635-.182.477.477 0 0 0 .059-.224c-.386-3.1 1.779-6.511 4.283-8.232a5.026 5.026 0 0 1 1.165-.635l.993 1.793c-.045.332-.834.831-1.1 1.077a8.153 8.153 0 0 0-1.808 2.243c-.775 1.461-1.341 3.423-.117 4.8a6.965 6.965 0 0 0 2.555 1.457 20.112 20.112 0 0 1 4.208 2.625.471.471 0 0 0 .772-.216c.722-2.194 4.012-2.163 5.493-3.657 1.321-1.332 1.376-3.374 1.479-5.139.1-1.7.1-5.966-1.286-8.225.538-.6 1.032-.5 1.484.318a9.258 9.258 0 0 1 .874 2.1 13.98 13.98 0 0 1 .477 3.829c.018 2.142-.278 4.279-.469 6.409a.467.467 0 0 0 .466.464c2.529-.177 6.631-2.031 7.073-4.82.685-4.326-2.7-8.981-4.887-12.348-1.181-1.814-3.53-4.519-3.761-6.755-.253-2.454 1.977-3.149 3.625-1.639a8.527 8.527 0 0 1 1.646 2.311 40.852 40.852 0 0 1 4.577 16.736.471.471 0 0 0 .478.463.464.464 0 0 0 .112-.016c1.92-.662 3.733-2.245 5.374-3.444a3.344 3.344 0 0 0 1.689-3.164c-.15-1.652-1.141-3.165-1.851-4.619a51.2 51.2 0 0 0-4.037-7.06 74.735 74.735 0 0 0-2.562-3.418 19.259 19.259 0 0 1-2.256-2.811c-.277-.553.3-2.716.958-2.913.634-.192 1.689.775 2.123 1.173a14.711 14.711 0 0 1 1.623 1.876c3.329 4.309 6.066 9.512 6.016 15.08a.471.471 0 0 0 .48.46.46.46 0 0 0 .22-.06c1.879-.851 2.734-3.433 3.406-5.226a20.872 20.872 0 0 0 1.272-9.234 19.3 19.3 0 0 0-8.794-14.65 5.512 5.512 0 0 1 2.451.076 4.221 4.221 0 0 1 1.958 1.134 17.42 17.42 0 0 0 1.813 2.08.472.472 0 0 0 .666-.021.455.455 0 0 0 .062-.084c1.379-2.715-.447-6.805-1.159-9.5M81.2 258.394a3.336 3.336 0 0 1-.551.447 1.846 1.846 0 0 1-1.651.418c-.08-.006-.156 0-.238-.01a.464.464 0 0 1-.324-.3l-.028-.029a.437.437 0 0 1-.36-.5.458.458 0 0 1 .06-.159 2.184 2.184 0 0 1 .975-.823c.037-.034.065-.072.1-.1a.462.462 0 0 1 .452-.089 3.811 3.811 0 0 1 1.009-.108.476.476 0 0 1 .449.34 1.3 1.3 0 0 1 .037.223c.02.017.042.025.061.043a.472.472 0 0 1 .009.652zm-.311-3.632a9.4 9.4 0 0 1-.634.009 4.974 4.974 0 0 1-2.036.093 1.526 1.526 0 0 1-1.224-.97.808.808 0 0 1-.288-1.006c.276-.562 1.1-.76 1.645-.909a.445.445 0 0 1 .24 0 3.878 3.878 0 0 1 3.8 1.067c.795 1.157-.557 1.664-1.5 1.715zm3.629-6.488c-.051.541-.62.823-1.1.909a3.342 3.342 0 0 1-1.332-.073 3.017 3.017 0 0 1-1.478-.353 1.141 1.141 0 0 1-.575-.851.369.369 0 0 1 0-.047 1.083 1.083 0 0 1 .8-1.133 3.841 3.841 0 0 1 2.881.417c.4.235.852.614.8 1.13zm8.491 5.233a.991.991 0 0 1-.393.641.336.336 0 0 1-.17.234 1.265 1.265 0 0 1-1.5.3.949.949 0 0 1-.5-.833 1.248 1.248 0 0 1-.1-.926.433.433 0 0 1 .038-.057.954.954 0 0 1 .723-.736c.765-.218 2.01.476 1.9 1.376z",
    style: {
      fill: "#acae37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2064",
    d: "M97.614 237.8c-4.267 1.5-5.975 6.48-9.094 9.407a.383.383 0 0 0-.2.195l-.03.029a.462.462 0 0 0-.163.447A70.865 70.865 0 0 0 85.7 255.7c-.215.725-.442 1.446-.672 2.165-.055.059-.1.129-.157.185a.488.488 0 0 0-.1.616c-.689 2.125-1.4 4.241-1.948 6.412a84.2 84.2 0 0 0-2.129 9.347c-.451 3.3-.072 6.274-.715 9.552-.114.586.169 1.181.284.593.545-2.772.809-5.572 1.139-8.374a74.275 74.275 0 0 1 2.114-10.073c.516-1.986.935-4.126 1.562-6.046.586-1.8 2-3.36 2.565-5.127a20.578 20.578 0 0 1 3.481-6.187c3.174-4.282 6.542-9.371 12.633-7.048.428.163.754-.309.681-.682-.6-3.032-4.146-4.182-6.824-3.236",
    style: {
      fill: "#b0bc34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2065",
    d: "M111.517 246.264c.237-1 .723-2.116 1.718-2.371a2.024 2.024 0 0 1 2.2 1.24 3.934 3.934 0 0 1 .01 2.7c-.264.879-.684 1.7-.959 2.58a8.181 8.181 0 0 0-.292 3.4 15.652 15.652 0 0 0 2.167 1.468 19.8 19.8 0 0 0 3.875 1.588 10.046 10.046 0 0 1-.4-1.573 3.751 3.751 0 0 1 .122-2.041 1.776 1.776 0 0 1 1.567-1.157c1.189.021 1.778 1.438 1.988 2.609a24.077 24.077 0 0 0 .637 3.043c1.806.284 3.635.445 5.423.56 2.025.13 3.265-.148 4.117-.936a7.489 7.489 0 0 0 1.724-3.754 50.732 50.732 0 0 0 1.787-9.078 11.143 11.143 0 0 0-1.4-1.33 10.687 10.687 0 0 1-2.822-2.578c-.654-1.1-.493-2.838.7-3.314a2.746 2.746 0 0 1 2.434.526c.158.1.293.236.444.349-.821-3.206-2.317-6.4-5.135-8.214-4.31-2.763-10.79-.326-11.879 4.275a5.888 5.888 0 0 0-.165 1.759 10.226 10.226 0 0 0-2.109-1.286c-2.283-2.058-8.138 2.625-9.019 4.785-1.53 3.717.216 8.008 2.93 11.324a14.627 14.627 0 0 1 .337-4.574",
    style: {
      fill: "#99991e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2066",
    d: "M93.541 336.956 98.75 302.6H41.016l5.208 34.356.028.182c1.376 8.63 9.142 14.791 17.872 14.791H75.64c8.73 0 16.5-6.161 17.872-14.791z",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2067",
    d: "m89.88 302.6-5.208 34.356-.028.182c-1.376 8.63-9.142 14.791-17.872 14.791h8.87c8.73 0 16.5-6.161 17.872-14.791l.029-.182 5.209-34.356z",
    style: {
      fill: "#08c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2068",
    d: "M332.329 384.476a13.258 13.258 0 0 0-9.609-7.075c-.789-.127-1.482-.241-2.139-.357-8.95 4.841-21.2 3.888-30.866.674-.013.053-.023.108-.036.16-.764 2.977-1.934 6.016-1.347 9.032a3.526 3.526 0 0 0 .839 1.828 4.515 4.515 0 0 0 3.3.89l22.063.029c3.2 0 17.292 2.015 18.386-1.527a5.055 5.055 0 0 0-.591-3.654",
    style: {
      fill: "#172e8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2069",
    d: "M320.585 377.044a14.771 14.771 0 0 1-7.787-3.432 19.161 19.161 0 0 1-6.829-9.633l-17.325 5.115c2 2.255 1.8 5.681 1.074 8.624 9.667 3.215 21.917 4.167 30.867-.674",
    style: {
      fill: "#f4bc95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2070",
    d: "M309.639 367.094 306.3 356c-.09-.3-.225-.64-.525-.715a.916.916 0 0 0-.488.061c-1.208.38-19.8 3.042-19.613 1.636-.413 3.07.223 9.81 2.678 12.135 1.2 1.134 4.664.352 6.253.245a91.679 91.679 0 0 0 15.037-2.27",
    style: {
      fill: "#3183b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2071",
    d: "M166.167 368.086a1.7 1.7 0 0 0-.013-1.029 1.587 1.587 0 0 0-.9-.684 19.846 19.846 0 0 0-8.816-1.488c-1.259.074-3.288-.135-4.242.872-1.217 1.284-1.671 4.809-2.247 6.5a8.749 8.749 0 0 1-1 2.225 160.888 160.888 0 0 1 16.9 1.668 28.065 28.065 0 0 1 .318-8.064",
    style: {
      fill: "#f4bc95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2072",
    d: "M165.827 376.154c-3.742-.541-7.5-1.007-11.266-1.321-1.413-.118-4.26-.854-5.575-.348-1.052.406-2.349 2.238-3.2 3.006a16.991 16.991 0 0 0-4.832 7.634c-.334 1.1-.457 2.521.476 3.2 1.345.977 4.4.973 5.979 1.081a66.913 66.913 0 0 0 7.521-.05l8.556-.373a4.194 4.194 0 0 0 1.905-.386 3.622 3.622 0 0 0 1.464-2.953c.262-2.914-.576-5.8-.957-8.7-.033-.266-.044-.527-.071-.79",
    style: {
      fill: "#172e8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2073",
    d: "M150.4 365.138a1.892 1.892 0 0 0-.127 1.584 2.1 2.1 0 0 0 1.626.742l15.211 2.047q1.881-5.737 3.269-11.6c-.292 1.233-13.964-3.169-15.281-2.974-4.212.619-3.536 7.133-4.7 10.2",
    style: {
      fill: "#3183b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2074",
    d: "M188.674 191.883c-1.765.184-6.593 14.741-7.42 16.75q-3.59 8.718-6.715 17.619-6.2 17.622-10.664 35.788A518.317 518.317 0 0 0 151.2 336c-.533 5.4-2.213 10.491-2.192 15.994a6.07 6.07 0 0 0 .369 2.436c.633 1.44 2.181 2.215 3.633 2.82a63.051 63.051 0 0 0 19.013 4.622 3.894 3.894 0 0 0 1.7-.12 3.728 3.728 0 0 0 1.71-1.753c2.884-4.919 3.728-10.918 5.651-16.247 1.506-4.173 2.506-8.589 3.748-12.923a191.17 191.17 0 0 1 10.254-27.488 234.247 234.247 0 0 1 13.729-25.273c1.493-2.4 17.617-24.283 17.115-24.943a374.653 374.653 0 0 1 33.264 52.017c4.753 9.012 9.151 18.208 13.29 27.518q3.27 7.353 6.341 14.792c1.351 3.256 2.354 10.694 5.789 11.928a21.881 21.881 0 0 0 7.651.967 73.225 73.225 0 0 0 12.843-1.272c8.684-1.644 2.825-19.791 1.806-25.643a309.3 309.3 0 0 0-7.433-32.16 438.952 438.952 0 0 0-23.318-61.626c-8.39-18.329-17.646-36.245-27.1-54.044z",
    style: {
      fill: "#3b2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2075",
    d: "M256.971 77.785a195.194 195.194 0 0 1 17.438-29.924c3.016-4.256 6.109-9.035 9.6-12.871 3.659-4.024 8.042-6.682 10.228-11.955 2.134-5.146 1.055-12.089-3.826-14.765-4.555-2.5-10.182-.442-14.853 1.83-8.394 4.083-16.566 8.89-23.483 15.218-3.1 2.83-5.219 5.917-7.67 9.17-2.917 3.869-6.892 7.1-10.069 10.8-17.9 20.825-28.927 46.873-35.337 73.589s-12.97 57.364-14.634 84.789c19.014 6.857 52.938 12.17 72.938 6.674.953-14.066 1.5-25.752 6.667-38.866 3.356-8.519 3.57-16.234 8.762-23.793 2.564-3.734 5.424-7.211 8.252-10.743 2.329-2.908 7.073-6.27 6.9-10.315-.128-2.992-2.73-5.2-5.135-6.983a269.555 269.555 0 0 0-28.236-18.784c-5.643-3.161-6.009-2.246-3.476-8.981q2.682-7.161 5.934-14.09",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2076",
    d: "M194.555 176.74c.716-5.406 1.633-10.783 2.445-16.176 1.08-7.161 1.912-14.34 3.354-21.444 1.682-8.288 1.36-14.977 4.311-22.906 1.419-3.816 3.53-19.635 14.792-49.951-9.484 16.238-16.061 34.265-20.463 52.608-6.41 26.716-12.97 57.364-14.635 84.789 3.3 1.19 7.069 2.327 11.117 3.376-3.129-9.73-2.243-20.331-.921-30.3",
    style: {
      fill: "#dc4820"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2077",
    d: "M288.444 92.742a92.567 92.567 0 0 0-5.764 8.774c-1.667 3.19-3.47 6.733-1.544 9.774a23.043 23.043 0 0 1-15.318-5.823 69.267 69.267 0 0 0 12.044-12.784 37.233 37.233 0 0 0 6.647-16.137 5.206 5.206 0 0 1 .983-2.952c2.5-2.682 7.169 1.414 7.3 4.163a27.645 27.645 0 0 1-4.353 14.985",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2078",
    d: "M242.424 104.062a11.514 11.514 0 0 0-.516 2.313c-.431 4.489 2.624 8.481 5.5 11.947a3.11 3.11 0 0 0 4.989.842l6.985-4.24c3.224-1.956 4.193-3.185 4.568-6.606.136-1.235 1.558-11.857.944-12.226a60.253 60.253 0 0 0-9.489-4.971c-3.145-1.2-7-2.266-10.313-1.238 2.32 3.82-1.248 9.661-2.673 14.179",
    style: {
      fill: "#e5a579"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2079",
    d: "M279.317 101.346c-2.715 2.781-5.814 5.4-9.585 6.274-6.14 1.427-12.465-2.193-16.568-6.984a31.268 31.268 0 0 1-7.4-18.3c-.437-7.232 1.569-15.175 6.7-20.395 3.709-3.776 9.564-4.749 14.767-3.785 6.336 1.173 13.144 3.9 17.972 8.253 6.012 5.422 6.727 13.008 3.955 20.481-1.989 5.364-5.561 10-9.526 14.126z",
    style: {
      fill: "#f5be96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2080",
    d: "M292.12 72.7a14.8 14.8 0 0 1 .659 3.279 15.258 15.258 0 0 1-1 6.835c-.4 1.029-3.143 4.276-2.793 5.234-.753-4.581-5.008-7.621-8.9-10.146-3.757-2.439-7.088-5-8.664-9.322-.819-2.242-.85-1.121-2.429.211-1.708 1.442-3.942 2.249-5.782 3.554a32.8 32.8 0 0 0-13.751 24.646 76.021 76.021 0 0 1-17.472-11.216c-.539-.461 1.471-5.678 1.725-6.4a44.382 44.382 0 0 1 3.02-6.714c2.468-4.463 6-7.539 9.039-11.481 2.449-3.175 4.694-5.506 8.637-6.917a21.989 21.989 0 0 1 11.655-.736c5.454 1.091 11.54 3.4 15.9 6.909 4.184 3.363 8.492 7.1 10.156 12.265",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2081",
    d: "M266.616 97.556a5.738 5.738 0 0 0 3.892 4.143c1.245.367 3.627.51 4.134-.978-1.117-.684-7.731-1.873-8.026-3.165",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2082",
    d: "m277.713 89.258-.3 6.025a2.216 2.216 0 0 1-.288 1.186 1.881 1.881 0 0 1-1.678.583 5.036 5.036 0 0 0-1.844.031",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#e5a579",
      strokeWidth: "2.184px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2083",
    d: "M283.608 92.563a2.048 2.048 0 0 0-3.217-1.378",
    style: {
      strokeWidth: "2.524px",
      stroke: "#212223",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2084",
    d: "M271.138 87.209a2.048 2.048 0 0 0-3.217-1.378",
    style: {
      strokeWidth: "2.524px",
      stroke: "#212223",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2085",
    d: "M285.967 90.355a6.817 6.817 0 0 0-5.933-3.254",
    style: {
      strokeWidth: "3.691px",
      stroke: "#212223",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2086",
    d: "M272.862 84.177a8.094 8.094 0 0 0-7.389-2.193",
    style: {
      strokeWidth: "3.691px",
      stroke: "#212223",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2087",
    d: "M257.633 79.795a4.337 4.337 0 0 0-.383-2.417 2.309 2.309 0 0 0-1.973-1.289 2.868 2.868 0 0 0-2.343 1.99 6.113 6.113 0 0 0 2.227 7.188z",
    style: {
      fill: "#f5be96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2088",
    d: "M251.962 194.062c-4.069-.952-8.319-.271-12.441.413a6.55 6.55 0 0 0 4.786 3.655 5.8 5.8 0 0 0-2.6.933 1.99 1.99 0 0 0-.648 2.471 2.9 2.9 0 0 0 1.528 1.006c1.88.718 3.645 1.531 5.483 2.3l-.208.5a10.41 10.41 0 0 0-3 .451 2.522 2.522 0 0 0 1.9 1.715 15.133 15.133 0 0 0 2.678.262 3.7 3.7 0 0 1 2.45.968c1.29 1.389 1.641 3.766 2.673 5.375 5.31 8.283 14.763 2.313 20.333-1.935l2.476-1.888a1.652 1.652 0 0 0 .764-.989 1.586 1.586 0 0 0-.3-.966c-.332-.582-4.675-6.736-5.333-6.448l-6.69 2.915c-1.258.548-2.861 1.05-3.879.13a3.585 3.585 0 0 1-.692-.985c-2.4-4.405-3.856-8.614-9.28-9.883",
    style: {
      fill: "#f5be96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2089",
    d: "M329.642 10.635a7.229 7.229 0 0 1-3.223-.8 34.238 34.238 0 0 0-3.9-1.981 12.837 12.837 0 0 0-8.169.019c-.423.143-.891.361-1.017.79a1.1 1.1 0 0 0 .288.986 4.822 4.822 0 0 0 2.37 1.532 4.831 4.831 0 0 1 1.529.667c.681.489 1.6 2.414.178 2.45a9.8 9.8 0 0 1-1.9-.412 61.58 61.58 0 0 0-2.588-.474c-1.179-.184-2.272.46-3.5.411a11.2 11.2 0 0 1-4.923-1.344 7.944 7.944 0 0 1-2.232-1.66 5.545 5.545 0 0 1-1.114-4.889 6.742 6.742 0 0 1 1.954-3.279 8.193 8.193 0 0 1 3.341-1.521 22.286 22.286 0 0 1 20.514 3.431 26.023 26.023 0 0 1 3.525 3.217 1.622 1.622 0 0 1-.826 2.828 2.935 2.935 0 0 1-.307.029",
    style: {
      fill: "#f5be96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2090",
    d: "M303.979 3.19a.448.448 0 0 1 .271.006.438.438 0 0 1 .171.188c1.383 2.331 1.417 5.425 3.318 7.356q-2.484 1.826-5.139 3.4c-3.449 2.047-7.174 3.825-9.845 6.818a1.815 1.815 0 0 1-.928.688 1.507 1.507 0 0 1-.579-.035 9.132 9.132 0 0 1-4.1-2.2A27.316 27.316 0 0 1 284 15.917a4.538 4.538 0 0 1-.861-1.388c-.511-1.578 1.17-2.464 2.22-3.239a45.133 45.133 0 0 1 4.125-2.709 45.645 45.645 0 0 1 9.066-4.027 44.919 44.919 0 0 1 5.43-1.364",
    style: {
      fill: "#f5be96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2091",
    d: "M305.03 153.062q.34 1.214.628 2.445c3.709 15.955-.856 31.517-10.843 44.156a68.512 68.512 0 0 1-7.5 8.377c-1.538 1.406-4.264 5.435-6.489 5.389-1.561-.033-2.5-1.676-3.234-3.057a33.271 33.271 0 0 0-6.234-8.3c-1.176-1.139-2.561-2.647-1.971-4.175a3.956 3.956 0 0 1 1.08-1.371c3.5-3.3 6.329-6.766 8-11.376a39.507 39.507 0 0 0 2-13.92c-.146-11.306-6.149-19.87-14.194-27.129-6.663-6.012-8.21-12.617-5.679-21.116 2.662-8.932 9.241-12.553 17.457-6.616 12.535 9.059 22.8 21.84 26.979 36.693",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2092",
    d: "M373.438 165.316c-1.232-.862-3.239-1.072-4.274.217-1.277 1.592.086 3.563.634 5.137a.526.526 0 0 0 .664.337.556.556 0 0 0 .087-.037.481.481 0 0 0 .615 0c1.135-.839 2.593-1.356 3.536-2.441 1.027-1.175-.262-2.513-1.262-3.213",
    style: {
      fill: "#3183b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2093",
    d: "M390.339 175.776c-.285 2.06-2.852 4.442-4 5.533a24.981 24.981 0 0 1-8.4 5.577c-1.3.45-3.733.742-2.516-1.371a16.31 16.31 0 0 1 3.581-3.86c.128-.1.243-.214.371-.317a53.027 53.027 0 0 1 5.144-3.921 30.373 30.373 0 0 1 4.651-2.564.853.853 0 0 1 1.169.923",
    style: {
      fill: "#3183b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2094",
    d: "M390.829 173.238a2.148 2.148 0 0 0-.3-.421 5.221 5.221 0 0 0-1.143-.648 29.66 29.66 0 0 1-1.572-1.028 43.859 43.859 0 0 0-6.11-3.914c-2.993-1.4-7.4-1.43-10.054.755-1.463 1.2-2.113 3.523-2.435 5.3-.716 3.979.74 7.367 2.558 10.688 1.037 2.156 2.265 4.774 5.041 4.366 3.935-.579 7.821-3.841 10.569-6.505a19.123 19.123 0 0 0 3.065-3.575 6.4 6.4 0 0 0 .926-2.233 4.973 4.973 0 0 0-.545-2.785m-4.5 8.07a24.779 24.779 0 0 1-8.394 5.573c-1.3.453-3.739.743-2.514-1.371a16.232 16.232 0 0 1 3.579-3.855 41.452 41.452 0 0 1 10.166-6.8.853.853 0 0 1 1.162.925c-.28 2.06-2.842 4.432-4 5.528z",
    style: {
      fill: "#e96627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2095",
    d: "M384.2 180.9a3.429 3.429 0 0 1-4.3.833 2.608 2.608 0 0 1-.523-.394 53.149 53.149 0 0 1 5.144-3.921 3.425 3.425 0 0 1-.321 3.482",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2096",
    d: "M355.189 222.719h-1.625l.52-31.462.083-.133 15.18-24.706.944.581-15.1 24.572z",
    style: {
      fill: "#3183b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2097",
    d: "M356.313 191.414a1.585 1.585 0 1 1-1.584-1.587 1.585 1.585 0 0 1 1.584 1.587",
    style: {
      fill: "#3183b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2098",
    d: "M365.862 224.454c-2.606-2.252-8.633-2.588-11.489-2.464a61.589 61.589 0 0 0-9.587 1.175c-.445.09-1 .34-.941.79.055.374.5.521.876.585 6.715 1.154 14.563 1.685 21.141-.086",
    style: {
      fill: "#3183b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2099",
    d: "m334.786 271.185-9.012 61.6h4.506l13.946-61.552z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2100",
    d: "m409.139 271.185 9.012 61.6h-4.506L399.7 271.233z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2101",
    d: "M422.22 224.233c-8.016-.364-65.741.447-100.751-.141l-.414 60.609a796.22 796.22 0 0 0 100.836-.166s1.962-39.452.329-60.3",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2102",
    d: "M417.314 274.995a104.322 104.322 0 0 0-.762-11.557q-.672-6.481-1.35-12.962a73.573 73.573 0 0 1-.5-10.628c.143-3.553.49-7.084.456-10.641a.581.581 0 0 0 .121-.811.569.569 0 0 0-.188-.164.553.553 0 0 0-1.026.179c-2.736.768-5.683.494-8.5.578-3.609.108-7.214.636-10.811.94-7.687.65-15.457.505-23.167.624-7.769.12-15.481-.3-23.24-.567-3.713-.13-7.434-.225-11.148-.178-2.528.032-5.49.454-7.884-.522a.431.431 0 0 0-.577.2l-.005.011a.51.51 0 0 0-.119.327c-.071 8.566-1.006 17.1-1.072 25.661s.826 17.1 0 25.657a.478.478 0 0 0 .421.531.464.464 0 0 0 .2-.018.578.578 0 0 0 .2.042c15.415.057 30.852 1.038 46.253.024 7.438-.49 14.813-1.11 22.278-.992 5.992.094 12.539 1.356 18.383-.388a.484.484 0 0 0 .1-.054.5.5 0 0 0 .433.054c1.776-.52 1.5-4.011 1.507-5.343m-87.6-44.4c2.053.606 4.4.389 6.482.351 3.7-.068 7.4 0 11.1.121 8.111.257 16.174.727 24.3.6 8.061-.124 16.168 0 24.2-.715 3.51-.313 7.027-.809 10.554-.863a33.366 33.366 0 0 0 7.709-.512c.039 5.9-.755 11.745-.27 17.665.189 2.305.416 4.609.658 6.912a.519.519 0 0 0-.12.048c-1.71 1.145-5.146.237-7.056.048-3.106-.307-6.246-.311-9.365-.308-7.688.007-15.375.185-23.065.184-7.72 0-15.443.059-23.163-.009-3.983-.035-7.965-.161-11.947-.232-3.584-.063-7.447.647-10.943-.274a.554.554 0 0 0-.1-.005c.163-7.675.918-15.33 1.026-23.011zm85.814 48.68a.484.484 0 0 0-.1.054.5.5 0 0 0-.433-.054c-6.171 1.842-13.334.37-19.674.33-7.3-.045-14.507.645-21.779 1.079-14.935.893-29.9-.02-44.84-.089.734-8.367-.1-16.726-.043-25.1 0-.255.012-.51.015-.766 3.1.765 6.271.23 9.431.251 4.163.028 8.326.193 12.487.245 8.45.1 16.9.019 25.355.021 8.2 0 16.4-.277 24.6-.17 2.9.038 5.748.226 8.628.491 1.6.147 3.852.557 5.394-.233q.313 2.937.637 5.871c.348 3.2.68 6.412.869 9.63.056 1.033.862 8.023-.553 8.444z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2103",
    d: "M374.022 240.854c.027-1.342-1.028-1.93-2.19-2.146a.542.542 0 0 0-.48-.352c-1.336-.1-2.891.366-2.976 1.936a3.589 3.589 0 0 0 1.727 3.033 2.507 2.507 0 0 0 3.418-.736 2.086 2.086 0 0 0 .44-1.276 2.149 2.149 0 0 0 .061-.459",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2104",
    d: "M374.022 267.727c.027-1.342-1.028-1.93-2.19-2.146a.542.542 0 0 0-.48-.352c-1.336-.1-2.891.366-2.976 1.935a3.589 3.589 0 0 0 1.724 3.036 2.507 2.507 0 0 0 3.418-.736 2.086 2.086 0 0 0 .44-1.276 2.149 2.149 0 0 0 .061-.459",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2105",
    d: "M417.741 221.26a6.882 6.882 0 0 0 1.094 2.84h-28.456a2.542 2.542 0 0 1-2.21-.7 4.6 4.6 0 0 1-1.371-3.359c.058-1.853 1.439-3.88 3.35-4.034 1.122-.091 2.291 0 3.417 0h25.628a7.075 7.075 0 0 0-1.452 5.253",
    style: {
      fill: "#b2bd33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2106",
    d: "M388.727 209.8s-3.2 2.713 0 6.165h25.044s-2.422-3.74 0-6.165z",
    style: {
      fill: "#e96627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2107",
    d: "M149.546 136.22H57.835V11.44h91.711zm-89-2.718h86.281V14.158H60.546z",
    style: {
      fill: "#46322b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2108",
    d: "M84.028 83.539c2.492-.416 4.956-.883 7.4-1.372a143.7 143.7 0 0 0-18.8-2.321v41.01h62.124V91.451c-14.643-2.523-29-6.656-43.327-9.283a229.09 229.09 0 0 1-7.4 1.371",
    style: {
      fill: "#b2bd33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2109",
    d: "M77.193 66.432c3.6-.6 7.256-1.135 10.938-1.648a97.144 97.144 0 0 0-15.5-.406v15.469a143.7 143.7 0 0 1 18.8 2.321c14.687-2.935 28.69-6.668 43.327-5.282v-6.133c-15.247-.148-30.88-4.421-46.627-5.969a411.4 411.4 0 0 0-10.938 1.648",
    style: {
      fill: "#e96627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2110",
    d: "M134.758 26.8H72.635v37.578a97.144 97.144 0 0 1 15.5.406c15.4-2.147 31.378-3.722 46.627-6.023z",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2111",
    d: "M134.757 58.76c-15.249 2.3-31.224 3.877-46.627 6.023 15.747 1.548 31.381 5.82 46.627 5.969z",
    style: {
      fill: "#3b2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2112",
    d: "M134.757 76.885c-14.636-1.385-28.64 2.347-43.327 5.282 14.332 2.626 28.684 6.76 43.327 9.283z",
    style: {
      fill: "#e96627"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutIllustration);
export default __webpack_public_path__ + "static/media/workout-illustration.199b80f36d0f4f673ce5cd0810c0dfe9.svg";
export { ForwardRef as ReactComponent };